import React, { useEffect, useState } from "react";
import Image from 'next/image';
import cssStyles from "./cms_renderer.module.scss";
import { SectionData, ComponentRenderProps } from "./index";
import Panel from "./Panel";
import { trackItem } from "@/utils";
import { useDeviceType } from "@/hooks/useDeviceType";

interface ContentOnImageProps {
    sectionData: SectionData;
    props: ComponentRenderProps;
}

const ContentOnImage = ({ sectionData, props }: ContentOnImageProps): JSX.Element | null => {
    //TODO: Add support for mobile
    const deviceType = useDeviceType();
    const [styles, setStyles] = useState(sectionData.uiCompType?.styles);
    useEffect(() => {
        if (deviceType === "Mobile" && sectionData.uiCompType?.mStyles) {
            setStyles(sectionData.uiCompType?.mStyles);
        }
    }, [deviceType, sectionData.uiCompType?.mStyles]);

    const panelClassName = "contentOnImage";
    const isPreload = sectionData.uiCompType?.options?.preload || false;

    const renderContentOnImage = () => (
        <div className={cssStyles[panelClassName + "Container"]} style={styles}>
            {sectionData.content && (
                <div className={cssStyles[panelClassName + "Content"]} style={(sectionData.content as SectionData)?.uiCompType?.parentStyles}>
                    {Panel({ sectionData: sectionData.content as SectionData, props })}
                </div>
            )}
            {sectionData.backgroundImageUrl && (
                <Image
                    alt={sectionData.title || sectionData.backgroundImageUrl || ''}
                    src={sectionData.backgroundImageUrl}
                    layout="fill"
                    objectFit="cover"
                    priority={isPreload}
                    loading={isPreload ? "eager" : "lazy"}
                />
            )}
        </div>
    );

    return sectionData.link ? (
        <a
            id={sectionData.trackId || ('link_')}
            href={sectionData.link}
            target={sectionData.newTab ? "_blank" : "_self"}
            onClick={(e) => {
                trackItem(sectionData.trackInfo || { event: 'contentOnImageLinkClick', section: sectionData.trackId });
            }}
        >
            {renderContentOnImage()}
        </a>
    ) : (
        renderContentOnImage()
    );
}
export default ContentOnImage;
